import { render } from "./RDFSummary.vue?vue&type=template&id=5b5180a6&scoped=true"
import script from "./RDFSummary.vue?vue&type=script&lang=js"
export * from "./RDFSummary.vue?vue&type=script&lang=js"

import "./RDFSummary.vue?vue&type=style&index=0&id=5b5180a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5180a6"]])

export default __exports__